import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import NewHomePage from './pages/NewHomePage';
import AboutPage from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import TemplatesPage from './pages/TemplatesPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import OnboardingPage from './pages/OnboardingPage';
import CareersPage from './pages/CareersPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import RolePlayPage from './pages/RolePlayPage';
import PricingPage from './pages/PricingPage';
import StaffingRecruitingPage from './pages/StaffingRecruitingPage';
import HealthcarePage from './pages/HealthcarePage';
import EducationPage from './pages/EducationPage';
import FranchisePage from './pages/FranchisePage';
import BanksPage from './pages/BanksPage';
import CallCentersPage from './pages/CallCentersPage';
import ConsultantsPage from './pages/ConsultantsPage';
import LogisticsPage from './pages/LogisticsPage';
import TechnologyPage from './pages/TechnologyPage';
import DefensePage from './pages/DefensePage';
import ExchangePage from './pages/ExchangePage';
import CadencePage from './pages/CadencePage';
import EnginePage from './pages/EnginePage';
import UpdatesPage from './pages/UpdatesPage';
import ThankYouPage from './pages/ThankYouPage';
import NotFoundPage from './pages/NotFoundPage';
import MouseSpotlight from './components/MouseSpotlight';
import CookieConsent from './components/CookieConsent';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <MouseSpotlight />
        <CookieConsent />
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<NewHomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/products/roleplay" element={<RolePlayPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/solutions/staffing-recruiting" element={<StaffingRecruitingPage />} />
          <Route path="/solutions/healthcare" element={<HealthcarePage />} />
          <Route path="/solutions/education" element={<EducationPage />} />
          <Route path="/solutions/franchise" element={<FranchisePage />} />
          <Route path="/solutions/banks-credit-unions" element={<BanksPage />} />
          <Route path="/solutions/call-centers" element={<CallCentersPage />} />
          <Route path="/solutions/consultants-trainers" element={<ConsultantsPage />} />
          <Route path="/solutions/logistics-trucking" element={<LogisticsPage />} />
          <Route path="/solutions/technology-platforms" element={<TechnologyPage />} />
          <Route path="/solutions/defense-government" element={<DefensePage />} />
          <Route path="/products/exchange" element={<ExchangePage />} />
          <Route path="/products/cadence" element={<CadencePage />} />
          <Route path="/products/engine" element={<EnginePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;